import React from 'react';
import './Nav.css';
import { Link, NavLink } from 'react-router-dom';

import { useSelector } from 'react-redux';
import { translate } from '../../i18n';
import { RootState } from '../../store';

export interface INavTitleProps {
    street: string;
    title: string;
    to: string;
    index: number;
    setActiveTab: (index: number) => void;
}

const NavTitle: React.FC<INavTitleProps> = (props) => {
    const activeColor = '#00A758';
    const innactiveColor = '#424559';
    const { language } = useSelector((state: RootState) => state.lang);

    return (
        <NavLink className="NavTab Welcome Drop-Shadow" to={props.to} style={{ textDecoration: 'none' }} onClick={() => props.setActiveTab(props.index)}>
            <div className="NavTabWelcomeTop">{translate(props.title, language)}</div>
            <div className="NavTabWelcomeBottom">{props.street}</div>
        </NavLink>
    );
};

export default NavTitle;
